import { computed } from 'vue';
import { useStore } from 'vuex';

export const useChatplanConnection = () => {
  const store = useStore();

  const isChatplanConnected = computed(
    () =>
      store.getters['license/hasValidatedLicense'] &&
      store.getters['license/isLicenseValid'] &&
      Boolean(store.getters['license/licenseStatus'])
  );

  return { isChatplanConnected };
};
